var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoComms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.22 0.5L0.5 18.22L1.77 19.5L6.65 14.62C9.76 17.43 13.81 19 18 19C18.2652 19 18.5196 18.8946 18.7071 18.7071C18.8946 18.5196 19 18.2652 19 18V14.5C19 14.2348 18.8946 13.9804 18.7071 13.7929C18.5196 13.6054 18.2652 13.5 18 13.5C16.75 13.5 15.55 13.3 14.43 12.93C14.08 12.82 13.69 12.9 13.41 13.18L11.21 15.38C10.06 14.8 9 14.06 8.06 13.21L19.5 1.77L18.22 0.5ZM2 1C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2C1 5.57 2.14 9.05 4.24 11.94L5.66 10.5C5.28 9.97 4.93 9.39 4.62 8.79L6.82 6.59C7.1 6.31 7.18 5.92 7.07 5.57C6.7 4.45 6.5 3.25 6.5 2C6.5 1.73478 6.39464 1.48043 6.20711 1.29289C6.01957 1.10536 5.76522 1 5.5 1H2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoComms);
export default __webpack_public_path__ + "static/media/NoComms.4874d7f466489d7fedac6d08b58e16a5.svg";
export { ForwardRef as ReactComponent };